import { tw } from '@careinfo/tailwind';
import { yupResolver } from '@hookform/resolvers/yup';
import { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AddSmsCampaign } from '../../../utils/validationSchemas';
import AddSmsModal from '../../QuickSms/AddQuickSmsModal/AddQuickSmsModal';
import Button from '../../Reusable/Button';
import Card from '../../Reusable/Card';
import * as XLSX from 'xlsx';
import MobilePreview from '../../Reusable/MobilePreview/MobilePreview';
import SmsCampaignForm from '../SmsCampaignForm/SmsCampaignForm';

const SmsCampaignCreate = (props: any) => {
  const { handleCreate, isPostLoading, refetch } = props;
  const {
    register,
    handleSubmit,
    watch,
    setError,
    setValue,
    getValues,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(AddSmsCampaign),
    defaultValues: async () => {
      const res = await refetch();
      return {
        sender_name: res?.data?.[0],
      };
    },
  });

  const message = watch('content');

  const [isAddEmailModalOpen, setIsAddEmailModalOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handlePlusButton = (e) => {
    e.preventDefault();
    setIsAddEmailModalOpen(true);
  };

  const handleFileButton = (e: React.MouseEvent) => {
    e.preventDefault();
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      });
      const phoneRegex =
        /(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{2,4}\)?[-.\s]?)?\d{3,4}[-.\s]?\d{4}/g;

      const extractedPhones: string[] = jsonData
        .flat()
        .filter((cell) => typeof cell === 'string')
        .flatMap((cell) => cell.match(phoneRegex) || []);

      const existing = watch('recipient') || [];
      const uniquePhones = Array.from(
        new Set([...existing, ...extractedPhones])
      );

      setValue('recipient', uniquePhones);
    } catch (err) {
      console.error('Failed to read Excel file', err);
    }

    e.target.value = '';
  };

  return (
    <div>
      <input
        type='file'
        ref={fileInputRef}
        accept='.xlsx,.xls'
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <div className={tw`pb-2`}>
        <h1 className={tw`text-lg font-semibold`}> SMS Campaign Create</h1>
      </div>
      <div className={tw`pt-4`}>
        <div className={tw`min-h-[550px]`}>
          <Card>
            <div className={tw`flex flex-col lg:flex-row gap-4`}>
              <div className={tw`w-full lg:w-3/4`}>
                <form
                  className={tw`flex flex-col gap-4`}
                  onSubmit={handleSubmit((data) => {
                    handleCreate(data, setError, false);
                  })}
                >
                  <SmsCampaignForm
                    register={register}
                    errors={errors}
                    control={control}
                    setValue={setValue}
                    watch={watch}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    handlePlusButton={handlePlusButton}
                    handleFileButton={handleFileButton}
                  />
                  <div className={tw`flex justify-end`}>
                    <div className={tw`mr-7`}>
                      <div className={tw`w-40`}>
                        <Button
                          label='Save Draft'
                          type='button'
                          onClick={handleSubmit((data) => {
                            handleCreate(data, setError, true);
                          })}
                          isLoading={isPostLoading}
                        />
                      </div>
                    </div>

                    <div className={tw`w-40`}>
                      <Button
                        label={'Send Now'}
                        type='submit'
                        isLoading={isPostLoading}
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div
                className={tw`hidden lg:flex items-center justify-center w-full lg:w-1/4`}
              >
                <div className='relative'>
                  <MobilePreview
                    imageUrl='https://dev-dib-pos-frontend-service-v3.s3.ap-south-1.amazonaws.com/digital-marketing-frontend-service/dist/30f7156109f80ad3a4d3.png'
                    description='Placeholders will be replaced for all contacts in a list. This is an example of the first contact.'
                    message={message}
                  />
                </div>
              </div>
            </div>
          </Card>
          <AddSmsModal
            isOpen={isAddEmailModalOpen}
            setIsOpen={setIsAddEmailModalOpen}
          />
        </div>
      </div>
    </div>
  );
};

export default SmsCampaignCreate;
